import React, { Component,useState,useEffect} from 'react';
import  { Redirect, useHistory, useLocation } from 'react-router-dom';
import realtimeDB from "../../Utils/api";
import styled from "styled-components";
import WhatsappButton from "../../Components/WhatsappButton";
import CustomerItemGrid from "../../Components/DGV/CustomerItemGrid";
import CustomerHeaderGrid from "../../Components/DGV/CustomerHeaderGrid";

const GridContainer=styled.div`
margin:2% 10%;`;

const TextHeader=styled.p`
font-weight:bold;
font-size:20px;
text-align:center;
border:2.5px solid #0088FF;
border-radius:10px;
padding:5px 0;
margin:5px 0;`;

class CustomerStatus extends Component 
{
    state=
    {
        loading:true,
        userExists:undefined,
        Customer:[],
        CustomersDouble:[],
        CustomersFourfold:[]
    }
    fetchUser=(id)=>
    {
        realtimeDB.ref("/Customers").child(id).on("value",(snapshot) =>
        {
            this.setState({userExists:snapshot.exists()});
            if(snapshot.exists())
            {
                var customer=snapshot.val();
                Object.assign(customer, {id: snapshot.key});
                this.setState({Customer:customer})
            }
        });
    }
    fetchAllUser=()=>
    {
        realtimeDB.ref("/Customers").on("value",(snapshot) =>
        {
            var Double=[];
            var Fourfold=[];
            snapshot.forEach((customer) =>
            {
                if(customer.val().status!=="served" && customer.val().status!=="cancelled" && customer.val().status!=="no-info")
                {
                    if(customer.val().dinersCount<=2)
                    {
                        var customerObject=customer.val();
                        Object.assign(customerObject, {id: customer.key});
                        Double.push(customerObject);
                    }
                    else
                    {
                        var customerObject=customer.val();
                        Object.assign(customerObject, {id: customer.key});
                        Fourfold.push(customerObject);
                    }
                }
            });
            this.setState
            ({
                CustomersDouble:Double,
                CustomersFourfold:Fourfold,
                loading:false
            })
        });
    }
    componentDidMount()
    {
        window.document.title="Lista Baum Lanús";
        const {match} =this.props;
        const id=match.params.id;
        this.fetchUser(id);
        this.fetchAllUser();
    }
    render() 
    {
        if(this.state.loading)
        {
            return "";
        }
        else
        {

            if(this.state.userExists===false)
            {
                return <Redirect to='/lista'/>
            }
            else
            {
                try
                {
                    if(this.state.Customer.status==="served")
                    {
                        return <Redirect to='/lista'/>
                    }
                }
                catch(error)
                {
                    return <Redirect to='/lista'/>
                }   
                if(this.state.loading)
                {
                    return "loading";
                }
                else
                {
                    const currentUser=this.state.Customer;
                    const dinersCount=parseInt(currentUser.dinersCount);
                    var CustomersOrder=[];
                    var C=undefined;
                    var index=undefined;               
                   if(dinersCount>2)
                   {
                        CustomersOrder=this.state.CustomersFourfold.sort((a, b) => (a.date > b.date ) ? 1 : (a.date  === b.date ) ? ((a.date  > b.date ) ? 1 : -1) : -1 );
                        C=this.state.CustomersFourfold.find(customer => customer.id === currentUser.id);
                        index=this.state.CustomersFourfold.indexOf(C);                  
                   }
                   if(dinersCount<=2)
                   {                  
                        CustomersOrder=this.state.CustomersDouble.sort((a, b) => (a.date > b.date ) ? 1 : (a.date  === b.date ) ? ((a.date  > b.date ) ? 1 : -1) : -1 );
                        C=this.state.CustomersDouble.find(customer => customer.id === currentUser.id);
                        index=this.state.CustomersDouble.indexOf(C);
                   }
                   
                   if(index===-1)
                   {
                        window.location.href = '/lista';
                   }
                   const withInfo=`Están en el puesto ${index+1} de la lista`;
                   const noInfo="Los llamamos y no estaban presentes! 😢 Por favor volverse a anotar en caso de necesitar la mesa";
                    return <React.Fragment>
                                <GridContainer>
                                    <TextHeader>{currentUser.status==="no-info" ? noInfo : withInfo}</TextHeader>
                                    <CustomerHeaderGrid/>
                                        {CustomersOrder.map(function(customer)
                                        {
                                            return  <CustomerItemGrid currentUser={currentUser} key={customer.id} date={customer.date} dinersCount={customer.dinersCount} name={customer.name}/>
                                        } 
                                        )}
                                </GridContainer>
                                <WhatsappButton number={"541138141940"} show={true} bottom={10}/>
                            </React.Fragment>
                }
            }
        }
    }
}

export default CustomerStatus